export const enum GENDER_TYPE {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    HIDDEN = 'HIDDEN'
}
